import React from 'react';
import '../../styles/GridBoxes.css';
import Vivo from '../../assets/9.jpg';

const translations = {
  en: {
    title1: "Own Your Slice of Paradise: Beachfront Lots in Puerto Escondido's Fastest-Growing Coastal Gem",
    title2: "Tourism Boom: 35% surge in tourism (2024) and direct flights from Houston (2025) driving demand",
    alt1: "Beachfront property illustration",
    alt2: "Tourism growth chart"
  },
  es: {
    title1: "Tu Porción de Paraíso: Terrenos Frente al Mar en la Joya Costera de Más Rápido Crecimiento de Puerto Escondido",
    title2: "Auge Turístico: 35% de aumento en turismo (2024) y vuelos directos desde Houston (2025) impulsan la demanda",
    alt1: "Ilustración de propiedad frente al mar",
    alt2: "Gráfico de crecimiento turístico"
  }
};

export default function MainBox({ MainBoxImage, language }) {
  return (
    <div className="mainbox">
      <h1>{translations[language].title1}</h1>
      <img 
        src={MainBoxImage} 
        height={400}  
        alt={translations[language].alt1} 
      />
      <h1>{translations[language].title2}</h1>
      <img 
        src={Vivo} 
        height={400}  
        alt={translations[language].alt2} 
      />
    </div>
  );
}